class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener("change", (e) => {
      const upsellProductItem = e.target.closest(".ts-cart__upsell-product");
      if (!upsellProductItem) return;

      const option = e.target.options[e.target.selectedIndex];
      upsellProductItem.querySelector('input[name="current_variant"]').value = option.value;
      upsellProductItem.querySelector('.ts-cart__upsell-price--compare').innerHTML = option.dataset.compare;
      upsellProductItem.querySelector('.ts-cart__upsell-price--main').innerHTML = option.dataset.price;
      if (upsellProductItem.querySelector(".ts-cart__upsell-product-media img")) {
        upsellProductItem.querySelector(".ts-cart__upsell-product-media img").src = option.dataset.image;
        upsellProductItem.querySelector(".ts-cart__upsell-product-media img").srcset = `${option.dataset.image} 300w`;
      }
    })

    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("ts-upsell-add")) {
        const upsellProductItem = e.target.closest(".ts-cart__upsell-product");
        const upsellProduct = parseInt(upsellProductItem.querySelector('input[name="current_variant"]').value);
        this.addUpsellItem(upsellProduct);
      }
    })
  }

  addUpsellItem(upsellProduct) {
    const sections = this.getSectionsToRender().map((section) => section.id);
    const cartData = {
      items: [
        {
          id: upsellProduct,
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        let error = new Error(response.description);
        throw error;
      } else {
        this.renderContents(response);
      }
    })
    .catch((error) => {
      console.error(error);
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      if (section.id == "cart-drawer") {
        const newDrawer = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');

        this.querySelector(".ts-cart__content").innerHTML = newDrawer.querySelector(".ts-cart__content").innerHTML;
        this.querySelector(".drawer__footer").innerHTML = newDrawer.querySelector(".drawer__footer").innerHTML;

        if (this.querySelector(".ts-cart__free-load")) {
          this.querySelector(".ts-cart__free-label").innerHTML = newDrawer.querySelector(".ts-cart__free-label").innerHTML;
          this.querySelector(".ts-cart__free-load").style.width = `${newDrawer.querySelector(".ts-cart__free-load").dataset.diff}%`;

          if (this.querySelector(".ts-cart__free").classList.value !==  newDrawer.querySelector(".ts-cart__free").classList.value) {
            this.querySelector(".ts-cart__free").classList.value = newDrawer.querySelector(".ts-cart__free").classList.value;

            this.querySelector(".ts-cart__free-notification").innerHTML = newDrawer.querySelector(".ts-cart__free-notification").innerHTML;

            this.querySelector(".ts-cart__free-notification").classList.add("open");
            setTimeout(() => {
              this.querySelector(".ts-cart__free-notification").classList.remove("open");
            }, 2000);
          }
        }
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
